import { display } from '~/utils/displayValues/common';
import { formatDollars } from '~/utils/formatNumber';
import { ContractType, UnitDecimals } from '~/constants';
import { Project } from '~/types/project';
import getDisplayValueCosts from './getDisiplayValueCosts';

export default function totals(project: Project, projectCosts: any, permissions: any) {
  const projectCostsData = getDisplayValueCosts(project, projectCosts);
  const { data, overall, perWdc, perKwh, bid } = projectCostsData || {};

  const isInvestor = permissions.hasProjectInvestorAccess && !permissions.isAdmin;

  let hasTotals: boolean = true;
  if (data?.isRejectedBid) {
    hasTotals = false;
  }

  // if (isInvestor && data?.isEpcProject && !bid) {
  //   hasTotals = false;
  // }


  if (isInvestor && project.pricingType !== 'OFFTAKE' && (!bid || (bid && !bid?.amount))) {
    hasTotals = false;
  }

  // if (isDeveloper && data?.isEpcProject && data?.isPendingBid) {
  //   hasTotals = false;
  // } 
 
  if (!hasTotals) {
    return {
      perKwh: 'TBD',
      perWdc: 'TBD',
      total: 'TBD'
    };
  }

  const bidOfftake = display(
    bid?.amount &&
      (project?.contractType === ContractType.LEASE || project?.contractType === ContractType.ENERGY_SERVICE_AGREEMENT)
        ? `${formatDollars(bid?.amount, { dec: UnitDecimals.YEAR, default0: 'TBD' })} /year`
        : `${formatDollars(bid?.amount, { dec: UnitDecimals.KWH, default0: 'TBD' })} /kWh`
  );

  return {
    perKwh: display(
      perKwh?.total && formatDollars(perKwh?.total, { dec: 2, default0: '' }),
      'TBD'
    ),
    perWdc: display(
      perWdc?.total && formatDollars(perWdc?.total, { dec: UnitDecimals.WDC, default0: '' }),
      'TBD'
    ),
    total: display(
      overall?.total && formatDollars(overall?.total, { dec: UnitDecimals.TOTAL, default0: '' }),
      'TBD'
    ),
    bidOfftake
  };
}